import React, { useEffect, useRef, useState } from 'react';
import { Box, Card, CardContent, Typography, IconButton, Rating } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useDispatch } from 'react-redux';
import { theme } from '../../../theme/theme';
import { useTranslation } from 'react-i18next';
import { TESTIMONIALS } from '../../../constants/testimonials';
// import { testimonials } from '../../../store/slices/testimonialSlice';
// import { errorHandler } from '../../../utils';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';

const TestimonialCarousel = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  // const [testimonial, setTestimonials] = useState([]);
  // const [isLoading, setIsLoading] = useState(false);
  const [slidesPerGroup, setSlidesPerGroup] = useState(1);

  const swiperRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const updateSlidesPerGroup = () => {
      const width = window.innerWidth;
      let newSlidesPerGroup;
      if (width >= 1024) {
        newSlidesPerGroup = 3;
      } else if (width >= 768) {
        newSlidesPerGroup = 2;
      } else {
        newSlidesPerGroup = 1;
      }

      setSlidesPerGroup(newSlidesPerGroup);

      if (swiperRef.current) {
        const maxIndex = Math.max(0, TESTIMONIALS.length - newSlidesPerGroup);
        if (swiperRef.current.activeIndex > maxIndex) {
          swiperRef.current.slideTo(maxIndex);
        }
      }
    };

    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateSlidesPerGroup, 200);
    };

    updateSlidesPerGroup();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimeout);
    };
  }, []);

  useEffect(() => {
    // (async () => {
    //   setIsLoading(true);
    //   try {
    //     const data = await dispatch(testimonials());
    //     if (data.payload.status === 200 && data.meta.requestStatus === 'fulfilled') {
    //       setTestimonials(data?.payload?.data);
    //     } else {
    //       console.log('No data found');
    //     }
    //   } catch (error) {
    //     console.error('Error', error);
    //     errorHandler(error);
    //   } finally {
    //     setIsLoading(false);
    //   }
    // })();
  }, [dispatch]);

  const totalSlides = TESTIMONIALS.length;
  const totalGroups = Math.ceil(totalSlides / slidesPerGroup) || 1;

  return (
    <Box
      sx={{
        padding: '60px 0 80px',
        backgroundColor: theme.palette.background.lightBlue,
        textAlign: 'center'
      }}>
      <Typography variant="h5" fontWeight={700} fontSize={'35px'} align="center" gutterBottom>
        {t('Testimonials')}
      </Typography>

      <Swiper
        onSlideChange={(swiper) => {
          console.log('Active Index:', swiper.activeIndex, 'Slides Per Group:', slidesPerGroup);
          setActiveIndex(swiper.activeIndex);
        }}
        spaceBetween={20}
        slidesPerView={slidesPerGroup}
        slidesPerGroup={slidesPerGroup}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        breakpoints={{
          0: { slidesPerView: 1, slidesPerGroup: 1 },
          768: { slidesPerView: 2, slidesPerGroup: 2 },
          1024: { slidesPerView: 3, slidesPerGroup: 3 }
        }}>
        {TESTIMONIALS.map((item) => (
          <SwiperSlide key={item.id} style={{ height: 'auto' }}>
            <Card
              sx={{
                display: 'flex',
                padding: '10px',
                borderRadius: '10px',
                border: '1px solid #d7e1ff',
                boxShadow: 'none',
                height: '100%',
                minHeight: '150px',
                textAlign: 'left',
                flex: 1
              }}>
              <CardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  padding: '16px'
                }}>
                <Box
                  mb={2}
                  display="flex"
                  alignItems="start"
                  justifyContent="space-between"
                  gap={2}>
                  <Box>
                    <Typography fontSize={18} color="#000" fontWeight={700}>
                      {item.name}
                    </Typography>
                    <Typography fontSize={12}>
                      {item.address} | {item.type} | {item.rooms}
                    </Typography>
                  </Box>
                  <Rating value={5} readOnly />
                </Box>
                <Typography
                  color="#000"
                  sx={{
                    flexGrow: 1
                  }}>
                  {item.testimonial}
                </Typography>
              </CardContent>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>

      <Box display="flex" gap={2} alignItems="center" justifyContent="center" mt={2} px={2}>
        <IconButton
          onClick={() => swiperRef.current?.slidePrev()}
          disabled={activeIndex === 0}
          sx={{
            color: '#929293',
            border: '1px solid #929293',
            height: '30px',
            width: '30px',
            opacity: activeIndex === 0 ? 0.5 : 1
          }}>
          <ArrowBackIcon sx={{ fontSize: '16px' }} />
        </IconButton>

        <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 1 }}>
          {Array.from({ length: totalGroups }).map((_, groupIndex) => {
            const targetSlide = groupIndex * slidesPerGroup;
            const isLastGroupVisible = activeIndex >= totalSlides - slidesPerGroup;
            const activeGroup = isLastGroupVisible
              ? totalGroups - 1
              : Math.floor(activeIndex / slidesPerGroup);
            const isActive = groupIndex === activeGroup;

            return (
              <Box
                key={groupIndex}
                onClick={() => {
                  const slideTo = Math.min(targetSlide, totalSlides - 1);
                  swiperRef.current?.slideTo(slideTo);
                }}
                sx={{
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%',
                  backgroundColor: isActive ? '#3f63ec' : '#ccc',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s'
                }}
              />
            );
          })}
        </Box>

        <IconButton
          onClick={() => swiperRef.current?.slideNext()}
          disabled={activeIndex >= totalSlides - slidesPerGroup}
          sx={{
            color: '#929293',
            border: '1px solid #929293',
            height: '30px',
            width: '30px',
            opacity: activeIndex >= totalSlides - slidesPerGroup ? 0.5 : 1
          }}>
          <ArrowForwardIcon sx={{ fontSize: '16px' }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default TestimonialCarousel;
